import { useTranslation } from "react-i18next";
import { useEnv } from "@/hooks/useEnv";

const reviewAuthors = [
  { name: "Алексей М.", location: "Москва, Россия", avatar: "АМ", color: "bg-[#007AFF]", key: "review1_text" },
  { name: "Асель К.", location: "Алматы, Казахстан", avatar: "АК", color: "bg-emerald-500", key: "review2_text" },
  { name: "Нурлан Б.", location: "Астана, Казахстан", avatar: "НБ", color: "bg-amber-500", key: "review3_text" },
];

export default function PersonalBusinessSection() {
  const { t } = useTranslation();

  const { contactEmail } = useEnv();

  return (
    <section id="business" className="py-16 relative overflow-hidden section-alt">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-px bg-gradient-to-r from-transparent via-[#007AFF]/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-6">
        {/* Business partners block */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-[#007AFF]/10 border border-[#007AFF]/20 rounded-full px-4 py-1.5 mb-5">
            <span className="text-[#007AFF] text-xs font-semibold tracking-wide uppercase">{t("pb_badge")}</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            {t("pb_title1")}
          </h2>
          <a
            href={`mailto:${contactEmail}`}
            className="inline-flex items-center gap-2.5 border border-gray-200 hover:border-[#007AFF]/40 text-gray-600 hover:text-[#007AFF] font-medium py-3 px-8 rounded-full cursor-pointer whitespace-nowrap transition-all duration-200 text-sm bg-white"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line text-sm" />
            </div>
            {contactEmail}
          </a>
        </div>

        {/* Testimonials */}
        <div className="mt-14">
          <div className="text-center mb-10">
            <div className="flex items-center justify-center gap-1 mb-3">
              {[1, 2, 3, 4, 5].map((s) => (
                <div key={s} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400 text-base" />
                </div>
              ))}
              <span className="text-gray-500 text-sm ml-2">{t("pb_reviews_rating")}</span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 tracking-tight">{t("pb_reviews_title")}</h3>
          </div>

          <div className="grid md:grid-cols-3 gap-4">
            {reviewAuthors.map((review) => (
              <div
                key={review.name}
                className="bg-white rounded-2xl border border-gray-100 p-6 flex flex-col gap-4 hover:border-gray-200 hover:shadow-sm transition-all duration-200"
              >
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-amber-400 text-sm" />
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed flex-1">&ldquo;{t(review.key)}&rdquo;</p>
                <div className="flex items-center gap-3 pt-2 border-t border-gray-50">
                  <div className={`w-9 h-9 rounded-full ${review.color} flex items-center justify-center shrink-0`}>
                    <span className="text-white text-xs font-bold">{review.avatar}</span>
                  </div>
                  <div>
                    <p className="text-gray-800 text-sm font-semibold leading-tight">{review.name}</p>
                    <p className="text-gray-400 text-xs">{review.location}</p>
                  </div>
                  <div className="ml-auto w-5 h-5 flex items-center justify-center">
                    <i className="ri-verified-badge-fill text-[#007AFF] text-base" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
